// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b52ce2eb","884":"da8aa29c"}[chunkId] + ".chunk.js";
};